import { Controller } from "@hotwired/stimulus"

// Filtert eine Checkbox-Liste (z. B. Mitarbeiter) nach Suchbegriff.
// Jedes Item braucht data-filter-checkbox-list-target="item" und data-filter-label="Suchtext".
export default class extends Controller {
  static targets = ["searchInput", "item"]

  filter() {
    const searchTerm = (this.searchInputTarget.value || "").toLowerCase().trim()

    this.itemTargets.forEach((item) => {
      const label = (item.dataset.filterLabel || "").toLowerCase()
      const matches = searchTerm === "" || label.includes(searchTerm)
      item.style.display = matches ? "" : "none"
    })
  }
}
